/**
 * What may paint the checkout scrim.
 *
 * A challenge sitting in a modal is NOT in-flight work — the guest is at
 * the bank. Folding that into the overlay is how "Procesando pago…" sealed
 * the screen after 3DS. A terminal unconfirmed/refunded state also must
 * not drive the scrim; it only disables a second charge.
 */
export type PaymentFlightFlags = {
  creatingHold: boolean
  charging: boolean
  confirming: boolean
}

export function isPaymentRequestInFlight(flags: PaymentFlightFlags): boolean {
  return flags.creatingHold || flags.charging || flags.confirming
}

export function isPayControlLocked(flags: PaymentFlightFlags & { unresolved: boolean }): boolean {
  return isPaymentRequestInFlight(flags) || flags.unresolved
}
